module.exports = __webpack_public_path__ + "static/media/discriptive report.075fc1fb.svg";